module.exports = __webpack_public_path__ + "static/img/渠道-1.dd68cdbf.png";